<template><svg xmlns="http://www.w3.org/2000/svg" width="36.029" height="36.029" viewBox="0 0 36.029 36.029">
    <g transform="translate(1 1)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
        <path d="M487.75,320v7.94l7.94,4.537,5.672-3.241" transform="translate(-487.75 -298.448)"/>
        <path d="M493,330.94V323" transform="translate(-485.06 -296.911)"/>
        <path d="M507.69,317l-7.94,4.537,7.94,4.537,7.94-4.537L507.69,317Z"
              transform="translate(-481.601 -299.986)"/>
        <path d="M499.75,320v7.94l7.94,4.537,7.94-4.537V320" transform="translate(-481.601 -298.448)"/>
        <path d="M505,323v7.94" transform="translate(-478.911 -296.911)"/>
        <path d="M501.69,305.75l-7.94,4.537,7.94,4.537,7.94-4.537-7.94-4.537Z"
              transform="translate(-484.676 -305.75)"/>
        <path d="M493.75,308.75v7.94l7.94,4.537,7.94-4.537v-7.94" transform="translate(-484.676 -304.213)"/>
        <path d="M499,311.75v7.94" transform="translate(-481.986 -302.676)"/>
        <path d="M501.362,320.241,495.69,317l-7.94,4.537,7.94,4.537,4.537-2.592"
              transform="translate(-487.75 -299.986)"/>
    </g>
</svg>
</template>